import gql from "graphql-tag";
import { getAuthenticationState } from "../../graphql/queries";

export default (
  _,
  { authenticated, selectedProject, needsToOnboard, uid, darkMode },
  { cache }
) => {
  const previousState = cache.readQuery({ query: getAuthenticationState });

  const data = {
    authenticationState: {
      ...previousState.authenticationState,
    },
  };

  if (typeof authenticated !== 'undefined') {
    data.authenticationState.authenticated = authenticated;
  }
  if (selectedProject) {
    data.authenticationState.selectedProject = selectedProject;
  }
  if (typeof needsToOnboard !== 'undefined') {
    data.authenticationState.needsToOnboard = needsToOnboard;
  }
  if (typeof uid !== 'undefined') {
    data.authenticationState.uid = uid;
  }
  
  if (typeof darkMode !== 'undefined') {
    data.authenticationState.darkMode = darkMode;
  }

  cache.writeQuery({
    query: getAuthenticationState,
    data,
  });

  return null;
};
